export class NavigatorUtils {
  /**
   * Returns the language of the browser, as a single ISO 639-1 code.
   */
  static getBrowserLanguage(): string {
    const lang = navigator.language;

    // Ensure ISO 639-1 language code is used, not the full locale ('en' not 'en-US')
    if (lang.includes('-')) {
      return lang.split('-')[0] ?? lang;
    }

    return lang;
  }
}

export class MiscUtils {
  static sanitizeCallsign(original: string): string {
    return original.trim().replace(/ {2,}/g, ' ');
  }
}
